<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
defineProps<{ comments: string[]; readonly: boolean; busy: boolean }>()
const emit = defineEmits<{ add: [text: string] }>()

const draft = ref('')

function submit(): void {
  const text = draft.value.trim()
  if (!text) return
  emit('add', text)
  draft.value = ''
}
</script>

<template>
  <div class="comments">
    <ul v-if="comments.length" class="list">
      <li v-for="(comment, index) in comments" :key="index">{{ comment }}</li>
    </ul>
    <p v-else class="ui-hint">{{ t('comments.none') }}</p>
    <form v-if="!readonly" class="add" @submit.prevent="submit">
      <textarea
        v-model="draft"
        class="ui-textarea"
        rows="2"
        :placeholder="t('comments.placeholder')"
        maxlength="4000"
        :disabled="busy"
      />
      <button type="submit" class="ui-btn ui-btn-primary" :disabled="busy || !draft.trim()">
        {{ t('comments.send') }}
      </button>
    </form>
  </div>
</template>

<style scoped>
.comments {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.3rem 0;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.list li {
  padding: 0.5rem 0.7rem;
  border-radius: 12px;
  background: var(--tg-secondary-bg-color);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.add {
  display: flex;
  gap: 0.4rem;
  align-items: flex-end;
}

p {
  margin: 0;
}
</style>
